import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TransitDetailComponentRoutingModule } from './transit-detail-routing.module';

import { TransitDetailComponent } from './transit-detail.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TransitDetailComponentRoutingModule],
  declarations: [TransitDetailComponent]
})
export class TransitDetailComponentModule {}
